export default "__VITE_ASSET__CCz0wzfq__"